import React, { useState } from 'react';
import styles from './styles.module.css';

const Tab = ({ tabItems }) => {
  const visibleTabs = tabItems.filter(item => !item?.hidden);
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div>
      <div className={`${styles['tab-container']}`}>
        {visibleTabs.map((item, index) => (
          <div
            key={index}
            onClick={() => setActiveTab(index)}
            className={`${styles['tab']} ${activeTab === index ? styles['active'] : ''} ${visibleTabs?.length === 1 ? styles['one-item'] : ''}`}
          >
            {item?.headName}
          </div>
        ))}
      </div>
      <div>
        {visibleTabs[activeTab]?.content}
      </div>
    </div>
  );
};

export default Tab;
